module.exports = __webpack_public_path__ + "static/GREENVILLE-5b39427e4d8dd3b80c53194fdb8dcbc5.png";